import { render } from "./newsInformationPage.vue?vue&type=template&id=45114f0f&scoped=true"
import script from "./newsInformationPage.vue?vue&type=script&lang=js"
export * from "./newsInformationPage.vue?vue&type=script&lang=js"

import "./newsInformationPage.vue?vue&type=style&index=0&id=45114f0f&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_269ca4a85a7eca3d5d7c9cc630d4bd5a/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45114f0f"]])

export default __exports__